import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import UploadPic from "../../../components/UploadPicMulti/UploadPic";
import { Button } from "primereact/button";

export default function P105Dialog({ dialog, setDialog, dataFile, setDataFile, onSaveFile, typeFile, onOpenDialog }) {
    useEffect(() => {
        if (dialog && dialog.act && dialog.act === "reload") {
            setDialog({ dialog: true, show: true });
        }
    }, [dialog.act]);

    return (
        <Dialog header="เพิ่มรูปถ่าย"
            visible={dialog.dialog}
            style={{ width: "45vw" }}
            className="p-fluid ___widthDialog"
            onHide={() => setDialog({ dialog: false, show: false })}
            blockScroll={true}
            maximizable={true}>
            <div className="p-grid" style={{ textAlign: "center" }}>
                <div className="p-col-12">
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-9"></div>
                        <div className="p-col-3">
                            <Button
                                className="p-button-warning p-button p-mr-2 p-mb-2"
                                icon="pi pi-folder"
                                label="ข้อมูลกล้องจากระบบ CIA"
                                // style={{ marginLeft: '5px' }}
                                style={{  marginLeft: "5px" }}
                            onClick={() => onOpenDialog()}
                            //disabled={disButton()}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* {dialog && dialog.show === true ?  */}
            <UploadPic setDialog={setDialog} dataFile={dataFile} setDataFile={setDataFile} onSaveFile={onSaveFile} typeFile={typeFile} />
            {/* : null} */}
        </Dialog>
    );
}
